export default __webpack_public_path__ + "media/images/video-placeholder-09cfb63ba4d0e57249cfbb40ec5abb51.png";